import React from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polygon,
} from "react-google-maps";
import millify from "millify";
var humanFormat = require("human-format");

let mapOptions = {
  zoomControl: true,
  cameraControl: false,
};
const MyMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_API}&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `250px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    options={mapOptions}
    defaultZoom={14}
    defaultCenter={{ lat: parseFloat(props.lat), lng: parseFloat(props.lang) }}
  >
    {(props.ismodal != undefined && props.ismodal) ||
    (props.home && props.home.length === 0) ? (
      <Marker
        position={{
          lat: parseFloat(props.lat),
          lng: parseFloat(props.lang),
        }}
        icon={props.imagedefault}
      ></Marker>
    ) : (
      props.home &&
      props.home.length > 0 &&
      props.home.map((marker) => {
        if (props.lat === marker.lat && props.lang === marker.lang) {
          return (
            <Marker
              //key={marker.id}
              //onClick={onClick}
              onClick={() => {
                window.open("/DetailsListing/?id=" + marker.id, "_blank");
              }}
              position={{
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lang),
              }}
              icon={props.imagedefault}
              // label={{
              // color: "white",
              // fontSize: '12px',
              // fontWeight: 'bold',
              // text:(marker && marker.price !== undefined) ? '$' + humanFormat(marker.price) : ""}}
              // labelStyle={props.labelStyle}
            ></Marker>
          );
        } else {
          return (
            <Marker
              //key={marker.id}
              //onClick={onClick}
              position={{
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lang),
              }}
              icon={props.icon}
              onClick={() => {
                window.open("/DetailsListing/?id=" + marker.id, "_blank");
              }}
              label={{
                color: "white",
                fontSize: "12px",
                fontWeight: "bold",
                text:
                  marker && marker.price !== undefined
                    ? "$" +
                      humanFormat(marker.price, {
                        decimals: marker.price.toString().length < 7 ? 0 : 2,
                      })
                    : "",
              }}
              labelStyle={props.labelStyle}
            ></Marker>
          );
        }
      })
    )}

    <Polygon
      path={getpolygons(props.poly)}
      options={{
        fillColor: getcolor(props.npiscore),
        strokeColor: "#c02e26",
        strokeWeight: 1,
        fillOpacity: 0.75,
      }}
      onClick={() => {
        window.open("/Neighborhood/" + props.nhfullname, "_blank");
      }}
    />
  </GoogleMap>
));

function getcolor(value) {
  let color = "";

  if (parseFloat(value) >= 91 && parseFloat(value) <= 100) {
    color = "#4d6a37";
  } else if (parseFloat(value) >= 81 && parseFloat(value) <= 90) {
    color = "#648d49";
  } else if (parseFloat(value) >= 71 && parseFloat(value) <= 80) {
    color = "#8daa78";
  } else if (parseFloat(value) >= 61 && parseFloat(value) <= 70) {
    color = "#b7d09c";
  } else if (parseFloat(value) >= 51 && parseFloat(value) <= 60) {
    color = "#cfdebe";
  } else if (parseFloat(value) >= 41 && parseFloat(value) <= 50) {
    color = "#f2df90";
  } else if (parseFloat(value) >= 31 && parseFloat(value) <= 40) {
    color = "#f9c467";
  } else if (parseFloat(value) >= 21 && parseFloat(value) <= 30) {
    color = "#ff8b24";
  } else if (parseFloat(value) >= 11 && parseFloat(value) <= 20) {
    color = "#ef4f09";
  } else if (parseFloat(value) >= 1 && parseFloat(value) <= 10) {
    color = "#c62733";
  } else {
    color = "#FFFFFF";
  }
  return color;
}

function getpolygons(data) {
  if (data) {
    const x = data.map((item) => {
      return { lat: item.x, lng: item.y };
    });
    return x;
  }
}

class NeighborMap extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  state = {
    isMarkerShown: false,
  };

  componentDidMount() {
    this.delayedShowMarker();
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true });
    }, 1000);
  };

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false });
    this.delayedShowMarker();
  };

  render() {
    let image, imagedefault;

    image = {
      url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/pricenew.png",
      // scaledSize: new google.maps.Size(50, 35),
      // strokeColor: "white",
      // origin: new google.maps.Point(0, 0),
      // anchor: new google.maps.Point(50, 35),
      // labelOrigin: new google.maps.Point(24, 12),
      // scale: 3
    };

    imagedefault = {
      url: process.env.NEXT_PUBLIC_CDN_ID + "static/images/mapdefault.png",
      // scaledSize: new google.maps.Size(50, 35),
      // strokeColor: "white",
      // origin: new google.maps.Point(0, 0),
      // anchor: new google.maps.Point(50, 35),
      // labelOrigin: new google.maps.Point(24, 12),
      // scale: 3
    };

    return (
      <MyMapComponent
        icon={image}
        imagedefault={imagedefault}
        isMarkerShown={this.state.isMarkerShown}
        //onMarkerClick={this.handleMarkerClick}
        lat={this.props.lat}
        lang={this.props.lang}
        poly={this.props.poly_data}
        home={this.props.homes}
        neighborid={this.props.neighbor_id}
        nhfullname={this.props.nhfullname}
        label="test"
        labelStyle={{ color: "#fff" }}
        npiscore={this.props.npiscore}
        ismodal={this.props.ismodal}
      />
    );
  }
}

export default NeighborMap;
